import * as React from "react";

// Import images as modules
import gordonImage from "../../assets/staff/herrick.jpg";
import whitneyImage from "../../assets/staff/whitney.jpg"; 

// Component for staff card
function StaffCard({ name, designation, description, imageSrc }) {
  return (
    <div className="flex flex-col md:flex-row w-full mb-8 items-center md:items-start text-left">
      {/* Image with responsive sizing */}
      <img
        loading="lazy"
        src={imageSrc}
        alt={`${name}'s headshot`}
        className="w-full md:w-1/4 h-auto object-cover mb-4 md:mb-0 max-w-full"
      />

      {/* Name, title, and description */}
      <div className="flex flex-col w-full md:w-1/2 text-center md:text-left md:ml-6">
        {/* Name and title centered on small screens */}
        <div className="text-2xl font-semibold text-zinc-800">{name}</div>
        <div className="mt-1 font-medium text-zinc-600">{designation}</div>

        {/* Description is centered and wraps properly on small screens */}
        <div className="mt-4 leading-6 text-neutral-500 text-left">
          {description}
        </div>
      </div>
    </div>
  );
}

export default function Staff() {
  const staffData = [
    {
      name: "Gordon Herrick, RN",
      designation: "House Provider",
      description:
        "Gordon Herrick, a Registered Nurse with over a decade of critical care experience, brings his expertise and compassion to Angel Haven as a house provider. His deep commitment to serving vulnerable populations led him to open a home where elderly care is prioritized. For Gordon, this work is part of a higher calling, serving families with a firm belief that caring for the elderly is part of God’s work.",
      imageSrc: gordonImage,
    },
    {
      name: "Whitney Herrick",
      designation: "House Manager",
      description:
        "As the House Manager at Angel Haven, Whitney Herrick ensures that every aspect of daily life runs smoothly for both residents and staff. From planning nutritious home-cooked meals and curating thoughtful dinner menus to organizing engaging outings, activities, and holiday family gatherings, Whitney brings warmth and care to everything she does.",
      imageSrc: whitneyImage,
    },
  ];

  return (
    <main className="container mt-10 flex flex-col">
      <h2 className="self-center text-5xl font-bold leading-[58.08px] text-zinc-800 max-md:max-w-full max-md:text-4xl">
        Meet Our Care Givers
      </h2>
      <section className="px-5 mt-16 w-full max-md:mt-10 max-md:max-w-full">
        {staffData.map((staff, index) => (
          <StaffCard
            key={index}
            name={staff.name}
            designation={staff.designation}
            description={staff.description}
            imageSrc={staff.imageSrc}
          />
        ))}
      </section>
    </main>
  );
}
